import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_UNIT, DELETE_UNIT, GET_UNIT, UPDATE_UNIT, GET_ONE_UNIT } from '../types';

export const getUnit = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/uqc/all`, { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_UNIT,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      // console.error('Failed to add Unit. Please try again. :', err);
   }
};

export const addUnit = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`${process.env.REACT_APP_BASEURL}/uqc/add`, formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_UNIT, payload: res.data.data });
         setTimeout(() => {
            toast.success('Unit added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      // toast.error('Failed to add Unit. Please try again. :', err);
   }
};

export const updateUnit = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/uqc/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_UNIT, payload: res.data.data });

         setTimeout(() => {
            toast.success('Unit updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update Unit. Please try again.');
   }
};

// Delete Unit
export const deleteUnit = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/uqc/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_UNIT, payload: { id } });
         setTimeout(() => {
            toast.success('Unit deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Unit. Please try again.');
   }
};

export const getSingleUnit = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/uqc/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_UNIT, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
